"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var LayoutStyles_1 = require("../../styles/LayoutStyles");
var Loader = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: LayoutStyles_1.LoaderContainerStyle },
        React.createElement(widgets_1.ActivitySpinnerWidget, { testId: 'dontShowUnderlay', shouldShowUnderlay: false }),
        children));
};
exports.Loader = Loader;
//# sourceMappingURL=Loader.js.map